import { ACTION_TYPES, useContratosDispatch, useContratosState } from "./contratos-context";
import MunicipalPortalAAppService from "application/platform/municipal-portal-service";
import { IContratoPagedRequest } from "models/request/contrato-paged-request";
import { downloadFile } from "utils/download-file";

export const useContratosController = () => {
    const contratosDispatch = useContratosDispatch();
    const { contratoPagedRequest } = useContratosState();

    async function exportContratos(format: string) {
        const file = await MunicipalPortalAAppService.exportContratos(contratoPagedRequest, format);
        downloadFile(file);
    }

    async function onInit() {
        let request = { page: 0, pageSize: 10 } as IContratoPagedRequest;

        contratosDispatch({ type: ACTION_TYPES.setContratoPagedRequest, payload: request });
        contratosDispatch({ type: ACTION_TYPES.setLoading, payload: true });

        await listContratos(request);
        await loadLookups();

        contratosDispatch({ type: ACTION_TYPES.setLoading, payload: false });
    }

    async function loadLookups() {
        try {
            const [tipos, situacoes, ultimaAtualizacao] = await Promise.all([
                MunicipalPortalAAppService.listTiposContrato(),
                MunicipalPortalAAppService.listSituacoesContrato(),
                MunicipalPortalAAppService.getContratosUltimaAtualizacao()
            ]);
            contratosDispatch({ type: ACTION_TYPES.setTipos, payload: tipos });
            contratosDispatch({ type: ACTION_TYPES.setSituacoes, payload: situacoes });
            contratosDispatch({ type: ACTION_TYPES.setUltimaAtualizacao, payload: ultimaAtualizacao?.dtaUltimaAtualizacao ?? null });
        } catch (error) {
            console.log(error);
        }
    }

    async function listContratos(request: IContratoPagedRequest, showLoading: boolean = false) {
        try {
            if (showLoading) {
                contratosDispatch({ type: ACTION_TYPES.setLoading, payload: true });
            }
            contratosDispatch({ type: ACTION_TYPES.setError, payload: null });

            const contratos = await MunicipalPortalAAppService.listContratos(request);

            contratosDispatch({ type: ACTION_TYPES.setContratos, payload: contratos });
        } catch (error) {
            console.log(error);
            contratosDispatch({ type: ACTION_TYPES.setError, payload: 'Não foi possível carregar os contratos. Tente novamente mais tarde.' });
        } finally {
            if (showLoading) {
                contratosDispatch({ type: ACTION_TYPES.setLoading, payload: false });
            }
        }
    }

    const handleOnChange = (e: any) => {
        let updated = { ...contratoPagedRequest };

        if (e.target.name === "text-field-term") {
            updated.term = e.target.value;
            if (!updated.term) {
                (async () => await listContratos({ ...updated, page: 0 }, true))();
            }
        } else if (e.target.name === "select-tipo-id") {
            updated.idTipoContrato = e.target.value;
        } else if (e.target.name === "select-situacao-id") {
            updated.idSituacaoContrato = e.target.value;
        } else if (e.target.name === "date-field-inicio") {
            updated.dataInicio = e.target.value;
        } else if (e.target.name === "date-field-fim") {
            updated.dataFim = e.target.value;
        } else if (e.target.name === "select-order-direction") {
            updated.orderDirection = e.target.value;
            (async () => await listContratos({ ...updated, page: 0 }, true))();
        }

        contratosDispatch({ type: ACTION_TYPES.setContratoPagedRequest, payload: updated });
    };

    return { listContratos, handleOnChange, onInit, exportContratos };
}
